import React from 'react';
import './SettingsPage.scss';
import Title from '../../shared/components/title/Title';
import Tabs from '../../shared/components/tabs/Tabs';
import { TabItem } from '../../shared/components/tabs/models/TabsModel';
import { useAccount } from '../../shared/contexts/account/AccountContexts';
import { useTranslation } from 'react-i18next';
import { isAdminOrOwner } from '../../shared/utils/utils';
import { AccountStatus } from '../../shared/types/account/AccountStatus';
import useBilling from '../../shared/hooks/account/UseBilling';

interface SettingsProps {
  children: React.ReactNode;
  restUrl: string;
}

const SettingsPage: React.FC<SettingsProps> = ({ children, restUrl }) => {
  const { t } = useTranslation();
  const { accountResponse } = useAccount();
  const canShowBilling = useBilling();
  const unsupportedStatus = ['TRIAL'] as AccountStatus[];
  const menuItems: TabItem[] = [
    {
      icon: 'id_card',
      url: `/settings/my-account`,
      label: t('myAccount'),
      isActive: restUrl === 'my-account',
    },
    {
      icon: 'password',
      url: `/settings/change-password`,
      label: t('changePassword'),
      isActive: restUrl === 'change-password',
    },
    ...(accountResponse &&
    isAdminOrOwner(accountResponse.role) &&
    accountResponse.customerId &&
    canShowBilling
      ? [
          {
            icon: 'receipt_long',
            url: `/settings/billing-data`,
            label: t('billingData'),
            isActive: restUrl === 'billing-data',
          },
        ]
      : []),
    ...(accountResponse && isAdminOrOwner(accountResponse.role) && canShowBilling
      ? [
          {
            icon: 'account_balance',
            url: `/settings/subscription`,
            label: t('subscription'),
            isActive: restUrl === 'subscription',
          },
        ]
      : []),
    ...(accountResponse &&
    !unsupportedStatus.includes(accountResponse.accountStatus) &&
    accountResponse.customerId &&
    canShowBilling &&
    isAdminOrOwner(accountResponse.role)
      ? [
          {
            icon: 'shopping_cart',
            url: `/settings/orders`,
            label: t('orders'),
            isActive: restUrl === 'orders',
          },
        ]
      : []),
    {
      icon: 'group',
      url: `/settings/team`,
      label: t('team'),
      isActive: restUrl === 'team',
    },
    {
      icon: 'group',
      url: `/settings/your-accounts`,
      label: t('yourAccounts'),
      isActive: restUrl === 'your-accounts',
    },
    ...(accountResponse?.addons?.includes('API_KEYS')
      ? [
          {
            icon: 'key',
            url: `/settings/api-keys`,
            label: t('apiKeys'),
            isActive: restUrl === 'api-keys',
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="page-content">
        <div className="page-box">
          <Title title={menuItems.filter((item) => item.isActive)[0]?.label ?? ''} />
          <Tabs items={menuItems} additionalClass="page-box__tabs" />
          <div className="page-box__content">
            <main>{children}</main>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsPage;
